import React from "react"

const Loading = () => {
  return (
    <>
      <h1 className="text-center text-3xl font-semibold tracking-wider">
        Loading...
      </h1>
    </>
  )
}

export default Loading
